import axios from 'axios';
import { logout } from '../helper/comman';
import { store } from '../redux/store';
import { BASE_API_URL } from 'helper/constant';

axios.interceptors.request.use(async (config) => {
  try {
    const {
      authReducer: { token },
    } = store.getState();
    if (token) {
      config.headers = {
        Authorization: `${token}`,
      };
    }

    return config;
  } catch (err) {
    Promise.reject(err);
  }
});

axios.interceptors.response.use(
  (res) => {
    return res;
  },
  (e) => {
    if (
      e.response?.status === 401 ||
      (e.response?.status === 403 &&
        !e.response?.request?.responseURL?.includes('/avatar'))
    ) {
      logout();

      return e.response;
    } else {
      return e.response;
    }
  }
);

export default axios;

export const axiosPost = (url, data) => {
  const {
    authReducer: { location },
  } = store.getState();
  return axios.post(`${location ? location : BASE_API_URL}/${url}`, data);
};

export const axiosGet = (url, data) => {
  const {
    authReducer: { location },
  } = store.getState();

  return axios.get(`${location ? location : BASE_API_URL}/${url}`, {
    params: data,
  });
};

export const axiosDelete = (url) => {
  const {
    authReducer: { location },
  } = store.getState();
  return axios.delete(`${location}/${url}`);
};

export const axiosPatch = (url, data) => {
  const {
    authReducer: { location },
  } = store.getState();

  return axios.patch(`${location ? location : BASE_API_URL}/${url}`, data);
};

export const fetchImage = (url, header) => {
  const {
    authReducer: { location },
  } = store.getState();
  return axios.get(`${location}/${url}`, header);
};
